module.exports = __webpack_public_path__ + "img/daffodil-whyspotcancerearly.15020e08.png";